import * as fromGraficoSelActions from '../../../actions/Componentes/Modelos/graficoSel.action';


export interface GraficoSState {
    action: string;
    grafico: any;
}

const initialStateGraficoSel: GraficoSState = {
    action: '',
    grafico : null
};

export function graficoSReducer(state = initialStateGraficoSel, action: fromGraficoSelActions.GraphicsActions): GraficoSState {
    switch (action.type) {
        case fromGraficoSelActions.SELECT_GRAPHIC:
            return {
                ...state,
                action: 'Select',
                grafico: action.GraficoSleccionado
            };
        case fromGraficoSelActions.UNSELECT_GRAPHIC:
            return {
                ...state,
                action: 'Unselect',
                grafico: null
            };
      default: {
        return state;
      }
    }
}